import { z } from "zod";

export const codeSchema = () => {
  return z.object({
    discount: z.number().min(1),
    code: z.string().min(1),
    used: z.boolean().optional().nullable(),
    reserved_for: z.string().optional().nullable(),
  });
};

export type CodeFormValues = z.infer<ReturnType<typeof codeSchema>>;
